// extracted by mini-css-extract-plugin
module.exports = {"ContentSideVideo":"styles_ContentSideVideo__3riWl","bg_1":"styles_bg_1___uSZ0","height":"styles_height__52QHM"};